export default function desabilitaCampos() {
    // regra para desabilitar todos os campos após serem salvos
    const inpuGeral = document.querySelectorAll('input, select, textarea');
    inpuGeral.forEach(input => {
        input.disabled = true;
        input.style.cursor = 'not-allowed';
        input.title = 'Para alterar este campo é necessário entrar em contato com a equipe de suporte.';
    });
}